// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-date-time[data-v-64571810]{display:flex}.container-date-time .date[data-v-64571810]{width:255px}.container-date-time .time[data-v-64571810]{margin-left:16px;width:200px}", ""]);
// Exports
module.exports = exports;
